import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdEdit, MdFilterAlt, MdMap, MdOutlineDescription, MdRssFeed } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { instanceId } = useParams();

  return (
    <Layout
      {...props}
      instanceElements={
        instanceId && (
          <Fragment>
            <NavListSectionHeader>NewsRPM Instance: {instanceId}</NavListSectionHeader>
            <NavLink to={`/admin/platform/newsrpm-instance/${instanceId}/article`}>
              <NavListItem icon={MdEdit}>Articles</NavListItem>
            </NavLink>
            <NavLink to={`/admin/platform/newsrpm-instance/${instanceId}/filter`}>
              <NavListItem icon={MdFilterAlt}>Content Filters</NavListItem>
            </NavLink>
            <NavLink to={`/admin/platform/newsrpm-instance/${instanceId}/destination`}>
              <NavListItem icon={MdMap}>Destinations</NavListItem>
            </NavLink>
            <NavLink to={`/admin/platform/newsrpm-instance/${instanceId}/feed`}>
              <NavListItem icon={MdRssFeed}>Output Feeds</NavListItem>
            </NavLink>
            <NavLink to={`/admin/platform/newsrpm-instance/${instanceId}/usage`}>
              <NavListItem icon={MdOutlineDescription}>Usage Reports</NavListItem>
            </NavLink>
          </Fragment>
        )
      }
    />
  );
}
